var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-content-releases",
    },
    [
      _c("courseware-content-links"),
      _vm._v(" "),
      _c("courseware-content-shared"),
      _vm._v(" "),
      _c("courseware-companion-overlay"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }